/**
 * Reads the stock data rendered by find-in-store-inventory.
 *
 * @returns {Object<string, Object<string, number>>} Stocked quantities by
 *   variant id, then store location id. Out-of-stock stores are left out.
 */
export function parseInventory(container) {
  try {
    return JSON.parse(
      container.querySelector("[data-find-in-store-inventory]").textContent,
    );
  } catch {
    return {};
  }
}
